import { type CatalogProducts } from '@vy/types';
import { caseInsensitiveIncludes, type Optional } from '@vy/utils';

export const filterCatalogProducts = (catalogProducts: CatalogProducts[], query: Optional<string>): CatalogProducts[] => {
    return catalogProducts.filter((product: CatalogProducts) =>
        !query || caseInsensitiveIncludes(product.name, query)
    );
};